import Vue        from 'vue'
// @ts-ignore
import SmartTable from 'vuejs-smart-table'

Vue.use(SmartTable)
